import { Tenant } from '@/apis/tenant/tenant'
import { getWechatIdps } from '@/utils'
import React, { useCallback, useContext } from 'react'
import { checkIsPcBrowser, checkIsWechatBrowser } from '@/utils/browser'
import {
  AuthenticationClient,
  SocialConnectionProvider,
  User
} from 'authing-js-sdk'

import urlResolve from '@jridgewell/resolve-uri'
import { AuthingConfigContext } from '@/components/authingWrapper'

interface Payload {
  data: Pick<
    {
      tenant: Tenant
    },
    'tenant'
  >
  onSuccess?: (user: User) => any
  callbackPath?: string
  redirect: string
}
export const useWechatAuth = ({
  data,
  redirect,
  callbackPath,
  onSuccess
}: Payload) => {
  const authingData = useContext(AuthingConfigContext)

  const tenantData = data?.tenant

  const wechatIpds = getWechatIdps(data)
  const wechatAuthFn = useCallback(() => {
    // pc微信扫码登录
    const isPcBrowser = checkIsPcBrowser()
    const isWechatBrowser = checkIsWechatBrowser()

    if (isPcBrowser) {
      const socialId = wechatIpds[SocialConnectionProvider.WECHATPC]
      new AuthenticationClient({
        token: '',
        appId: authingData.AUTHING_APP_ID,
        appHost: authingData.AUTHING_APP_HOST
      }).social.authorize(socialId, {
        onError: (code, message) => {
          console.error('social auth error', code, message)
        },
        onSuccess: (user) => {
          console.log('social auth success', user)
          onSuccess(user);
        }
      })
      return
    }

    // 微信内点击了「微信登录」
    if (isWechatBrowser) {
      console.log('print callbackPath value', callbackPath)

      const redirectUrl = encodeURIComponent(
        urlResolve(
          `${callbackPath || '/auth/api/third'}?redirect=${encodeURIComponent(
            redirect
          )}`,
          window.origin
        )
      )
      console.log('print useWechat redirectUrl', redirectUrl)
      const socialId = wechatIpds[SocialConnectionProvider.WECHATMP]
      window.location.href = `https://core.authing.cn/connections/social/${socialId}?app_id=${
        authingData.AUTHING_APP_ID
      }&redirect_url=${redirectUrl}&tenant_id=${tenantData?.authingId || ''}`
      return
    }
  }, [tenantData, authingData, wechatIpds])

  return { wechatAuthFn }
}
